/* eslint-disable @typescript-eslint/restrict-template-expressions */
import { generatePath } from 'react-router';
import queryString from 'query-string';
const API_PREFIX = '/api/v1';
const API_PREFIX_V2 = '/api/v2';
const CUMULATED_VALUES_BY_POST = '/analytics/post/:postuid/aggregated';
const CUMULATED_VALUES_BY_LOCATION =
  '/analytics/location/:locationSlug/aggregated';
const POSTS_COUNT_PER_DAY = '/posts/statistics';
const TOP_POSTS = '/images/dashboard/short_post_list';
const POSTS_ANALYTICS = '/images/posts/mulitplatformsocialmediapost';

const POST_ANALYTICS = '/images/posts/mulitplatformsocialmediapost/:postuuid';
// const LOCATION_DETAILS = '/locations/details';

const LOCATION_DETAILS = '/locations/locations/:locationslug';
const LOCATIONS_LIST = '/locations/locations';

const USER_DETAILS = '/users';
const MANAGE_TEAM = '/accounts/team';
const POST_DETAILS_PERIODICALDATA = '/analytics/post/:uuid/periodicaldata';
const POST_DETAILS_AGGREGATED = '/analytics/post/:uuid/aggregated';
const MANAGE_TEAM_MEMBER = '/accounts/team/:uuid';
const MANAGE_INVITES = '/accounts/invites';
const MANAGE_INVITE = '/accounts/invites/:uuid';
const CLOUDS_LIST = '/clouds';
const SUBSCRIPTION_MANAGEMENT_STATUS =
  '/subscription-management/users/team/status';
const COMMUNICATION_CONVERSATION = '/communication/conversation/:uuid';
const COMMUNICATION_MESSAGES = '/communication/messages';
const UPDATE_MESSAGE = '/communication/messages/:uuid';
const MEMBERS_LIST = '/accounts/team/members';
const LABELS_LIST = '/communication/conversation_labels';
const UPDATE_LABEL = '/communication/conversation_labels/:uuid';
const CONVERSATIONS_FILTER = '/communication/conversation_cache';
const CONVERSATIONS_BULK_OPERATION = '/communication/bulk_update';
const CREATE_POST_MEDIA = '/posts/upload_url';
const PLANNED_POSTS = '/posts/planned';
const ALL_LOCATIONS_TAGS = '/locations/location_tags';
const CREATOR_POSTS = '/posts/creator/multipostplatformsocialmediapost';
const CREATOR_POSTS_BY_ID =
  '/posts/creator/multipostplatformsocialmediapost/:uuid';
const EXTERNAL_CONTENT_COLLECT = '/posts/external_content_collect';
const POST_IDEAS_LIST = '/posts/post_idea';
const COCKPIT_CONTENT_COLLECTION_CONFIGURATION =
  '/lomavis-content-submission/locations/:locationslug/configuration';
const COCKPIT_CONTENT_COLLECTION_CONFIGURATION_REGENERATE =
  '/lomavis-content-submission/locations/:locationslug/configuration/regenerate';
const VIDEO_EDIT_URL = '/posts/request_video_edit';

const NOTIFICATIONS = '/notifications/account_notifications_summary';
const LOCATION_BRANDING_SETTINGS = '/locations/:locationUUID/settings';

const LOMAVIS_AI_SETTINGS = '/ai_assistant/lomavis_ai_settings/:uuid';
const LOMAVIS_AI_MESSAGES = '/ai_assistant/lomavis_ai_chat_messages';
const LOMAVIS_AI_MESSAGES_BULK_DELETE =
  '/ai_assistant/lomavis_ai_chat_messages/bulk-delete';

const GET_WHATSAPP_TEMPLATES =
  '/communication/platforms/whatsapp/message_templates';
const GET_TEXT_BLOCK_FOLDERS = '/textblocks/folder';
const GET_SINGLE_TEXT_BLOCK_FOLDER = '/textblocks/folder/:folderUUID';
const GET_TEXT_BLOCK_CAPTIONS = '/textblocks/saved_text_block';
const GET_SINGLE_TEXT_BLOCK_CAPTIONS =
  '/textblocks/saved_text_block/:captionUUID';
const APPROVAL_PROCESS_USERS = '/approval_process/approval-users';
const APPROVAL_PROCESS_GROUPS = '/approval_process/approval-groups';
const APPROVAL_PROCESS_GROUPS_EDIT = '/approval_process/approval-groups/:uuid';
const CREATOR_DEFAULT_SETTINGS =
  '/posts/creator/default-settings/:locationUuid';

const MEDIA_METADATA = '/posts/external-media/metadata';

const MEDIA_DOWNLOAD_URL = '/posts/external-media/download';

const ANALYTICS_DEMOGRAPHICS = '/analytics/demographics';

const ANALYTICS_BEST_TIME_TO_POST = '/analytics/best-time-to-post';
const LOCATION_SETTINGS = '/locations/:locationUuid/settings';
const URL_SHORTENER = '/url-shortener/shorten';
const META_ADS_TARGETING = '/platforms/facebook/search/meta-ads-targeting';
const CAMPAIGNS = '/posts/campaign';
const CAMPAIGNS_DETAIL = '/posts/campaign/:uuid';
const INSTAGRAM_AUDIO_SEARCH =
  '/posts/creator/locations/:locationUuid/instagram-audio-search';
const COMPETITOR_ANALYSIS = '/competitor-analysis/competitor-profiles';
const SINGLE_COMPETITOR_ANALYSIS =
  '/competitor-analysis/competitor-profiles/:uuid';
export const FACEBOOK_COMPETITOR_SEARCH =
  '/platforms/facebook/account/facebook/:uuid/search/accounts';
const CURRENT_SUBSCRIPTION = '/subscription/current';
const AD_ANALYTICS = '/paid-ads/ad-campaigns';
const AD_CAMPAIGN_DRAFTS = '/paid-ads/ad-manager/campaigns';
const AD_CAMPAIGN_DRAFT_DETAIL = '/paid-ads/ad-manager/campaigns/:uuid';
const AD_CAMPAIGN_DRAFT_PUBLISH =
  '/paid-ads/ad-manager/campaigns/:uuid/publish';
const AD_CAMPAIGN_DRAFT_COPY = '/paid-ads/ad-manager/campaigns/:uuid/copy';
const AD_CAMPAIGN_DRAFT_ACTIVITY =
  '/paid-ads/ad-manager/campaigns/:uuid/activity';
const AD_CAMPAIGN_DRAFT_SET_STATUS =
  '/paid-ads/ad-manager/campaigns/:uuid/set-status';
const AD_CAMPAIGN_COUNTRY_OPTIONS = '/paid-ads/ad-manager/country-options';
const AD_CAMPAIGN_PIXELS = '/paid-ads/ad-manager/pixels';
const AD_CAMPAIGN_AUDIENCE_ESTIMATE = '/paid-ads/ad-manager/audience-estimate';
const AD_CAMPAIGN_VALIDATE_INTERESTS =
  '/paid-ads/ad-manager/validate-interests';
const AD_CAMPAIGN_CUSTOM_AUDIENCES = '/paid-ads/ad-manager/custom-audiences';
const OVERLAY_TEMPLATES = '/overlay-templates/templates';
const OVERLAY_TEMPLATE = '/overlay-templates/templates/:uuid';
const OVERLAY_TEMPLATE_FOLDERS = '/overlay-templates/folders';
const OVERLAY_TEMPLATE_FOLDER = '/overlay-templates/folders/:uuid';

const endpointsMap: any = {
  cumulated_by_posts: CUMULATED_VALUES_BY_POST,
  cumulated_by_location: CUMULATED_VALUES_BY_LOCATION,
  posts_count: POSTS_COUNT_PER_DAY,
  top_posts: TOP_POSTS,
  posts_analytics: POSTS_ANALYTICS,
  location_details: LOCATION_DETAILS,
  post_details_periodicaldata: POST_DETAILS_PERIODICALDATA,
  post_details_aggregated: POST_DETAILS_AGGREGATED,
  post_analytics: POST_ANALYTICS,
  user_details: USER_DETAILS,
  manage_team: MANAGE_TEAM,
  manage_team_member: MANAGE_TEAM_MEMBER,
  manage_invites: MANAGE_INVITES,
  manage_invite: MANAGE_INVITE,
  locations_list: LOCATIONS_LIST,
  clouds_list: CLOUDS_LIST,
  subscription_management_status: SUBSCRIPTION_MANAGEMENT_STATUS,
  communication_conversation: COMMUNICATION_CONVERSATION,
  communication_messages: COMMUNICATION_MESSAGES,
  update_message: UPDATE_MESSAGE,
  members_list: MEMBERS_LIST,
  labels_list: LABELS_LIST,
  update_label: UPDATE_LABEL,
  conversations_filter: CONVERSATIONS_FILTER,
  conversations_bulk_operation: CONVERSATIONS_BULK_OPERATION,
  create_post_media: CREATE_POST_MEDIA,
  planned_posts: PLANNED_POSTS,
  locations_tags: ALL_LOCATIONS_TAGS,
  creator_posts: CREATOR_POSTS,
  creator_posts_by_id: CREATOR_POSTS_BY_ID,
  external_content_collect: EXTERNAL_CONTENT_COLLECT,
  post_ideas_list: POST_IDEAS_LIST,
  cockpit_content_collection_configuration:
    COCKPIT_CONTENT_COLLECTION_CONFIGURATION,
  cockpit_content_collection_configuration_regenerate:
    COCKPIT_CONTENT_COLLECTION_CONFIGURATION_REGENERATE,
  generate_video_edit_url: VIDEO_EDIT_URL,
  notifications: NOTIFICATIONS,
  location_branding_settings: LOCATION_BRANDING_SETTINGS,
  lomavis_ai_settings: LOMAVIS_AI_SETTINGS,
  lomavis_ai_messages: LOMAVIS_AI_MESSAGES,
  lomavis_ai_messages_bulk_delete: LOMAVIS_AI_MESSAGES_BULK_DELETE,
  get_whatsapp_templates: GET_WHATSAPP_TEMPLATES,
  get_text_block_folders: GET_TEXT_BLOCK_FOLDERS,
  get_single_text_block_folder: GET_SINGLE_TEXT_BLOCK_FOLDER,
  get_text_block_captions: GET_TEXT_BLOCK_CAPTIONS,
  get_single_text_block_captions: GET_SINGLE_TEXT_BLOCK_CAPTIONS,
  approval_process_users: APPROVAL_PROCESS_USERS,
  approval_process_groups: APPROVAL_PROCESS_GROUPS,
  approval_process_groups_edit: APPROVAL_PROCESS_GROUPS_EDIT,
  creator_default_settings: CREATOR_DEFAULT_SETTINGS,
  media_metadata: MEDIA_METADATA,
  media_download_url: MEDIA_DOWNLOAD_URL,
  analytics_best_time_to_post: ANALYTICS_BEST_TIME_TO_POST,
  location_settings: LOCATION_SETTINGS,
  analytics_demographics: ANALYTICS_DEMOGRAPHICS,
  url_shortener: URL_SHORTENER,
  competitor_analysis: COMPETITOR_ANALYSIS,
  single_competitor_analysis: SINGLE_COMPETITOR_ANALYSIS,
  facebook_competitor_search: FACEBOOK_COMPETITOR_SEARCH,
  meta_ads_targeting: META_ADS_TARGETING,
  campaigns: CAMPAIGNS,
  campaigns_detail: CAMPAIGNS_DETAIL,
  instagram_audio_search: INSTAGRAM_AUDIO_SEARCH,
  current_subscription: CURRENT_SUBSCRIPTION,
  ad_analytics: AD_ANALYTICS,
  ad_campaign_drafts: AD_CAMPAIGN_DRAFTS,
  ad_campaign_draft_detail: AD_CAMPAIGN_DRAFT_DETAIL,
  ad_campaign_draft_publish: AD_CAMPAIGN_DRAFT_PUBLISH,
  ad_campaign_draft_copy: AD_CAMPAIGN_DRAFT_COPY,
  ad_campaign_draft_activity: AD_CAMPAIGN_DRAFT_ACTIVITY,
  ad_campaign_draft_set_status: AD_CAMPAIGN_DRAFT_SET_STATUS,
  ad_campaign_country_options: AD_CAMPAIGN_COUNTRY_OPTIONS,
  ad_campaign_pixels: AD_CAMPAIGN_PIXELS,
  ad_campaign_audience_estimate: AD_CAMPAIGN_AUDIENCE_ESTIMATE,
  ad_campaign_validate_interests: AD_CAMPAIGN_VALIDATE_INTERESTS,
  ad_campaign_custom_audiences: AD_CAMPAIGN_CUSTOM_AUDIENCES,
  overlay_templates: OVERLAY_TEMPLATES,
  overlay_template: OVERLAY_TEMPLATE,
  overlay_template_folders: OVERLAY_TEMPLATE_FOLDERS,
  overlay_template_folder: OVERLAY_TEMPLATE_FOLDER
};
const API_V2_LIST = new Set([
  'communication_conversation',
  'communication_messages',
  'update_message',
  'labels_list',
  'conversations_filter',
  'conversations_bulk_operation',
  'update_label',
  'create_post_media',
  'creator_posts',
  'creator_posts_by_id',
  'external_content_collect',
  'generate_video_edit_url',
  'post_ideas_list',
  'cockpit_content_collection_configuration',
  'cockpit_content_collection_configuration_regenerate',
  'lomavis_ai_settings',
  'lomavis_ai_messages',
  'lomavis_ai_messages_bulk_delete',
  'notifications',
  'get_whatsapp_templates',
  'get_text_block_folders',
  'get_single_text_block_folder',
  'get_text_block_captions',
  'get_single_text_block_captions',
  'approval_process_users',
  'approval_process_groups',
  'approval_process_groups_edit',
  'creator_default_settings',
  'media_metadata',
  'media_download_url',
  'analytics_demographics',
  'analytics_best_time_to_post',
  'url_shortener',
  'campaigns',
  'campaigns_detail',
  'competitor_analysis',
  'single_competitor_analysis',
  'instagram_audio_search',
  'current_subscription',
  'ad_analytics',
  'ad_campaign_drafts',
  'ad_campaign_draft_detail',
  'ad_campaign_draft_publish',
  'ad_campaign_draft_copy',
  'ad_campaign_draft_activity',
  'ad_campaign_draft_set_status',
  'ad_campaign_country_options',
  'ad_campaign_pixels',
  'ad_campaign_audience_estimate',
  'ad_campaign_validate_interests',
  'ad_campaign_custom_audiences',
  'overlay_templates',
  'overlay_template',
  'overlay_template_folders',
  'overlay_template_folder'
]);

export const resolve = (
  urlName: string,
  urlParams: object,
  query: object
): string => {
  const prefix = API_V2_LIST.has(urlName) ? API_PREFIX_V2 : API_PREFIX;
  // generate the URL using the urlName, urlParams, query and API_PREFIX

  let url = generatePath(`${prefix}${endpointsMap[urlName]}/`, urlParams);

  if (url.substring(url.length - 1) !== '/') {
    url += '/';
  }

  return Object.keys(query).length > 0
    ? `${url}?${queryString.stringify(query, {
        arrayFormat: 'comma'
      })}`
    : url;
};

export const resolveForNavigation = (
  urlName: string,
  urlParams: object,
  query: object,
  hashTagNavigation: boolean = false
): string => {
  let url = generatePath(`${urlName}/`, urlParams);

  if (hashTagNavigation && url.substring(url.length - 1) === '/') {
    url = url.substring(0, url.length - 1);
  }

  return Object.keys(query).length > 0
    ? `${url}?${queryString.stringify(query, {
        arrayFormat: 'comma'
      })}`
    : url;
};
